module.exports = __webpack_public_path__ + "static/media/CloudStrife.586f62b8.jpg";